module.exports = {
  GENERATE_JWT_TOKEN: "generate jwt token",
  UPDATE_USERNAME: "/updateEmployerName",
  UPDATE_EMAILID: "update emailid",
  USER_VERIFY: "user verification",
  GENERATE_MOBILE_OTP: "generate mobile otp",
  VERIFY_MOBILE_OTP: "verify mobile otp",
  VERIFY_AADHAR_OTP: "verify aadhar otp",
  UPDATE_PAN: "update Pan",
  GETSERVICE: "get service",
  Menu_Option: "Menu Option",
  Update_Address: "Update Address",
  UpdateService: "Update Service",
  GETDYNAMICFIELD: "get_dynamic_Field",
  Overdue_Menu_Option: "Menu Option",
  terms_condition: "terms_and_condition",
  get_overdue_details: "overdue details",
  getQuickPayDetails: "getQuickPayDetails",
  getCarAPI: "getCarAPI",
  get_pqOffer_details: "getPqOfferDetails",
  get_maste_date: "getMasterDate",
  getEasyPay: "getEazyPay",
  transactionStatus: "getTransactionDetails",
  VALIDATESR_TAG: "validateSr",
  DISCREPANT_SUCCESS_TAG: "submitDiscrepantDoc",
  DEACTIVATE_TOKEN: "deActivateToken",
  GENERATEAADHAR: "generateAadhar",
  AADHARVALIDATE: "aadharValidate",
  VERIFYPAN: "verifyPan",
  CONFIRMSRDETAILS: "confirmSRDetails",
  GETSRDETAILS: "getSRDetails",
  GETCONFIRMDETAILS: "getConfirmDetails",
  SMSTOCUSTOMER: "smsToCustomer",
  GETSERVICEDETAILS: "getServiceDetails",
  GETPINCODEDETAILS: "transferAccount",
  GETPINCODEDETAIL: "getPincodeDetails",
  GETDECRYPTEDDATA: "decryptedData",
  GETREKYCDECRYPTEDDATA: "rekycDecryptedData",
  GETREKYCDECRYPTEDDATATESTSERVICE: "getDecryptedTestDataService",
  UPLOADFILES: "uplaodFiles",
  VERIFYACCOUNTNUMBER: "getAccountStatus",
  GETORDERDETAILS: "getOrderDetails",
  SAVETRANSACTIONDETAILS: "getCreditDetails",
  GETIINDETAILS: "getIinNpciDetails",
  GETBANKDETAILS: "getBankName",
  GETLANGAUGE: "getLanguage",
  GETPAYMENTDETAILS: "getPaymentDetails",
  GETPQTRANSACTIONDETAILS: "getPqTransactionDetails",
  SENDDETAILS: "sendDetails",
  VERIFYCREDIT: "getCreditStatus",
  GETDEBITDETAILS: "getDebitDetails",
  GETDEBITUSERDETAILS: "getDebitUserDetails",
  GETCHEQUESTATUS: "getChequeStatus",
  GETOVERDUEMENU: "getOverdueMenuItem",
  GETCIBIL: "getCibilDetails",
  GETBITLY: "redirectBitly",
  SENDSMS: "sendSms",
  CONSENTWHATSAPP: "getConsentDetails",
  GETUSERDETAILS: "getCustomerDetials",
  GETPPACODE: "getPpaCode",
  GETFILEDATA: "updateDocument",
  GETCITY: "getCityDetails",
  GETYEAR: "getYearDetails",
  GETMFG: "getManufacturerDetails",
  GETMODEL: "getModelDetails",
  GETVARIANT: "getVariantDetails",
  VERIFYLOANNUMBER: "getLoanStatus",
  GETCARDEKHOLOCATIONDETAILS: "getCarDekhoLocationDetails",
  GETPRICINGDETAILS: "getPricingDetails",
  GETLEADGENERATIONDETAILS: "getLeadGenerationDetails",
  VERIFYDEBITCARD: "getDebitStatus",
  VERIFYAUTODEBITCARD: "getAutopayStatus",
  GETUSERDETAIL: "getUserDetails",
  GENERATE_JWT_TOKEN_NLI: "getToken",
  GETSERVICE_NLI: "getService",
  GETDROPDOWNLIST: "getDropdownList",
  SUBMITFORMGRIEVANCE: "submitGrievanceForm",
  DEACTIVATE_TOKEN_NLI: "deactivateToken",
  GRIEVANCE_SEARCH: "GrievanceSearch",
  PINCODE: "pinCode",
  GETFOREXDETAILTAG: "getForexDetail",
  GETHOMEPROPERTYDETAILTAG: "getHomePropertyDetail",
  GETSEARCH: "getSearchDetails",
  CONVERTTRANSACTIONTOEMI: "convertTransactionToEMI",
  VERIFYDMATNUMBER: "getInvestMentStatus",
  GETIANMGES: "getGravityOffers",
  GETCREDITDETAILS: "getCreditDetails",
  GETTINMASTERDETAILS: "getTinMasterDetails",
  GETBANKUSERDETAILS: "getBankUserDetails",
  VERIFYCOMMUNICATIONADDRESS: "getProfileDetails",
  GETCREDITACCOUNTS: "getCreditNumbers",
  GETGOOGLELOC: "getGeoLocStatus",
  GET_CANCELMANDATE: "getCancelAutoDebitMandateDetails",
  GETBRANCHLISTFORSWAPPING_TAG: "deptMasterList",
  GET_DELIVERABLES: "getDeliverables",
  GRIDAUTHENTICATIONCSP: "gridAuthentication",
  ESIGN_SESSION_DBT_TAG:'getEsignSession',
  ESIGN_UPDATE_DBT_TAG:'getSignedDocument',
  GETBANKMASTERLIST_TAG:'bankMasterList',
  //rekyc
  DEACTIVATE_REKYC_TOKEN: "deActivateToken",
  REFRESH_REKYC_TOKEN: "refreshToken",
  GENERATE_JWT_TOKEN_REKYC: "generateJWTTokenRekyc",
  VALIDATE_PAN: "validatePan",
  PAN_VALIDATION:'panValidation',
  GET_MASTER_DATA: "getMasterData",
  GET_ALL_MASTER_DATA: "getAllMasterData",
  UPDATE_PROFILE_MASTER: "updateProfileMaster",
  GET_ACCOUNT_EMAIL: "getAccountEmail",
  GET_UPDATED_EMAIL: "getUpdatedEmail",
  GET_EMAIL_OTP: "getEmailOtp",
  VERIFY_EMAIL_OTP: "verifyEmailOtp",
  GET_AADHAAR_OTP: "getAadhaarOtp",
  VERIFY_AADHAAR_OTP: "verifyAadhaarOtp",
  UPDATE_FATCA_DETAILS: "updateFatcaDetails",
  GET_REKYC_DETAILS: "getRekycDetails",
  SAVE_DEVICE_DETAILS: "saveDeviceDetails",
  GET_GEOLOCATION: "getGeoLocStatus",
  UPDATE_CURRENT_ADDRESS: "updateCurrentAddr",
  GET_ESIGN_SESSION: "getEsignSession",
  DELETE_ESIGN_DOCS: "deleteEsignDoc",
  GET_SIGNED_DOCUMENT: "getSignedDocument",
  PROCEED_VKYC: "proceedVideoKYC",

  //data quality
  DEACTIVATE_DATAQUALITY_TOKEN: "deActivateToken",
  REFRESH_DATAQUALITY_TOKEN: "refreshToken",
  GENERATE_JWT_TOKEN_DATAQUALITY: "generateJWTTokenRekyc",
  GET_DATAQUALITY_DETAILS: "getRekycDetails",
  GETDATAQUALITYDECRYPTEDDATA: "rekycDecryptedData",
  GETDATAQUALITYDECRYPTEDDATATESTSERVICE: "getDecryptedTestDataService",

  // nli
  GETNSEDETAILS: "getNseDetail",
  SUBMITFEEDBACKDETAILS: "getFeedbackDetail",
  SUBMITSERVICEREQUEST: "submitServiceRequest",
  GETUNCLAIMEDDEPOSITTAG: "getUnclaimedDeposit",
  GETSHAREHOLDERTAG: "getShareHolderTag",
  GETINVESTORUPLOADTAG: "getInvestorUploadTag",
  GETPOSTAG: "getPOStag",
  GETUNCLAIMEDDIVIDENTTAG: "getUnclaimedDivident",
  GETCOMPLIMENTTAG: "getComplimentTag",
  GETGDPRTAG: "getGdprtag",
  GETKYCTAG: "getKYctag",
  GETQRTAG: "getQrtag",
  CALL_OVERDUE_ONCLOSE: "callOverdue",
  CARLOANDASHBOARD_TAG: "getCarLoanStatus",
  TPU_TAG: "getTpuDetails",
  RTGS_TAG: "getRTGSDetails",
  NEFTFUNDS_TAG: "getNeftDetail",
  ICICIFUNDS_TAG: "getICIFUNDS",
  GETCASHKARODETAILS: "getCashKaroDetails",
  GETLOANQRDETAILS_TAG: "getLoanQrDetails",
  GENERATE_VERIFY_OTP: "generateVerifyOTP",
  GET_EMAIL_OTP_TAG:"getEmailOtp",


  //Pebble
  UPDATEVARIANT: "updateVariant",
  GENERATE_SR: "generateSR",
  UPLOAD_FILES_PEBBLE: "uploadFilesPebble",
  GRIDAUTHPEBBLE_TAG: "gridAuthentication",
  GETDEBITPEBBLE_TAG: "getDebitDetails",
  GENERATEPDF_TAG: "generatePDF",
  STATECITYDETAIL_TAG: "stateCityStatusDetail",
  GETBRANCHBYPIN: "getBranchByPin",
  COUNTRY: "countryDropdown",
  GETOTP: "getMobileOtpTIo",
  GETSBNROCONVERSION: "getSbNroConvertion",
  VERIFY_OTP_TIO: "verifyOTP",
  VERIFYDEBITPIN: "validateDebitCardPin",
  GETBANKERSCERTIFICATE_TAG: "getBankersCertificate-tag",
  GETCONVERSIONPDF_TAG: "getConversionPDF-tag",
  GETCONFIRMATIONPDF_TAG: "getConfirmationPDF-tag",
  GRIDAUTHENTICATION: "gridAuthentication",
  GETCARDNUMBER_TAG: "getCardNumber-tag",
  UPDATEESTATEMENT: "updateEStatement",
  UPDATEETRADEALERTS: "updateETradeAlerts",
  UPDATEEMAILMOB: "updateEmailMob",
  GETCONVERSIONAUTOSAVE: "getAutoSavedDetails",
  GETCONVERSIONFILE: "getDownloadFile",
  GENERATEOTPUPDATE: "sendOtpForPin",
  VERIFYYOTPUPDATE: "sendOtpForPin",
  GENERATEOTPUPDATEDEBIT: "sendOtpForPin",
  VERIFYYOTPUPDATEDEBIT: "sendOtpForPin",
  PREPAIDBLOCK_TAG: "cardBlock",
  PREPAIDUNBLOCK_TAG: "cardUnblock",
  PREPAIDPIN_TAG: "cardPin",
  PREPAIDACTIVE_TAG: "activate card",
  PREPAIDACTIVATE_TAG: "activate card",
  PREPAIDCARDDETAIL_TAG: "prepaidCardDetail",
  PREPAIDUSER_TAG: "prepaidUSERDetail",
  SETTLEMENT_TAG: "settlementRequest",
  PREPAIDREGISTER_TAG: "prepaidUSERREGISTER",
  PREPAIDDISPATCH_TAG: "prepaidUSERcardDispatch",
  GETFORECLOSEDETAILS_TAG: "getForeCloseDetails",
  CITYSTATE_TAG: "cityStateTag",
  VISITINDIA_TAG: "visitIndia",
  AURAACCOUNTDETAIL_TAG: "auraAccountDetails",
  AURAACCOUNTSUBMIT_TAG: "auraSubmit",
  OFFERPORTALDETAILS_TAG: "offerPortalDetails",
  GRIDCARDACCOUNTNUMBER_TAG: "accountDet",
  GRIDCARDDEBITCARDNUMBER_TAG: "getDebitDetails",
  GETDONATIONDETAILS_TAG: "getDonationDetails",
  GET_DECRYPTED_DATA_GRID: "getDecryptedDataGrid",

  // Data governance
  GETDECRYPTEDDATA_TAG: "decryptData",
  VERIFYPANDGOV_TAG: "verifyPan",
  EMAILOTP__TAG: "generateEmailOtp",
  VERIFYEMAIL__TAG: "verifyEmailOtp",
  GRIDAUTH__TAG: "gridAuthDgov",
  GET_MASTER_DATE: "getMasterDate",
  SUBMITCUSTOMER_TAG: "submitCustomerdDet",
  GET_SOURCE_TAG: "getSourceId",
  GETACCOUNTS__TAG: "accounts",
  //data governance end

  //Dual residency
  GETDECRYPTEDDATA_DUALTAG: "decryptData",
  SUBMITCUSTOMER_DUALTAG: "submitCustomerdDet",

  //Dual residency
  GETDECRYPTEDDATA_ACCAGG_TAG: "decryptData",
  GET_TXN_STATUS_TAG: "getTxnStatus",
  GET_CONCENT_TAG: "getConcent",

  //Overdue Income tax certificate
  GET_INCOMETAX_TAG: "getLoanNumbers",

// Imobile services
  GET_DECRYPTED_CASH_WITHDRAWAL: 'getDecryptedCashWithdrawal',
  RAISE_SERVICE_REQUEST: 'raiseServiceRequest',
  GET_MOBILE_OTP: 'sendOtp',
  VERIFY_OTP: 'verifyOtp',

  // * minor to major
  M2M_GRIDCARDDEBITCARDNUMBER_TAG: 'getDebitDetails',
  M2M_GRIDAUTHPEBBLE_TAG: 'gridAuthentication',
  M2M_VALIDATE_USER: 'm2mValidateUser',
  M2M_GET_USER_DETAILS: 'm2mGetUserDetails',
  M2M_GET_M_OTP: 'm2mGetMotp',
  M2M_VERIFY_M_OTP_TAG: 'verifyMOtp',
  M2M_GET_E_OTP_TAG: 'getEotp',
  M2M_VERIFY_E_OTP_TAG: 'verifyEOtp',
  M2M_GET_A_OTP_TAG: 'getAotp',
  M2M_VERIFY_A_OTP_TAG: 'verifyAOtp',
  M2M_GET_MASTER_LIST_TAG: 'getMasterList',
  M2M_VALIDATE_PAN_TAG: 'validatePan',
  M2M_GET_GEOLOCATION_TAG: 'getGeoLoc',
  M2M_GET_TOKEN_TAG: 'getToken',
  M2M_GET_NOMINEEE_TAG: 'getNominee',
  M2M_GET_APPLICABLE_PRODUCTS_TAG: 'getApplicableProduct',
  M2M_SUBMIT_TAG: 'submit',
  M2M_VKYC_TAG: 'vkycInitiate',
  M2M_VKYC_FROM_URL_TAG: ' vkycFromUrl',
  M2M_VALIDATE_URL_TAG: 'validateM2mUrl',
  M2M_CRM_UPDATE_TAG: 'crmUpdate',

  // * forex doorstep
  FOREX_DOORSTEP_GET_CURRENCY: "getCurrency",
  FOREX_DOORSTEP_GET_CONVERSION_RATES: "getConversionRates",
  FOREX_DOORSTEP_GET_PINCODE_MASTER: "getPincodeMaster",
  FOREX_DOORSTEP_GET_PINCODE_DETAILS: "getPincodeDetails",
  FOREX_DOORSTEP_TOTAL_AMOUNT_PAYABLE: "totalAmountPayable",
  FOREX_DOORSTEP_VERIFY_USER: "verifyUser",
  FOREX_PURCHASE_REQ_GENERATION: "purchaseReqGeneration",
  FOREX_DOORSTEP_TRIGGER_OTP: "getDoorStepOtp",
  FOREX_DOORSTEP_VERIFY_OTP: "verifyDoorstepOtp",
  FOREX_DOORSTEP_VERIFY_GRID_AUTH: "doorstepGridAuthentication",
  FOREX_DOORSTEP_GET_PROMO_CODES: "promoCode",
  FOREX_DOORSTEP_PASSPORT_VERIFICATION: "passportVerification",
  FOREX_DOORSTEP_SSO_DECRYPTED_DATA: "getdecryptedData",

  //rekyc nochange
  REKYC_NOCHANGE_TAG: "getDecryptedData",
  REKYC_NOCHANGE_SR_TAG: 'noChangeSRDeatils',

  // digilocker
  GET_DIGI_LOCKER_URL: 'getDigilockerUrl',
  GET_DIGI_LOCKER_ISSUER_DOCUMENT: 'getIssuerDocument',
  GET_DIGI_LOCKER_EAADHAAR_DATA: 'getEaadhaarData',

  //NEFT/RTGS
  FETCH_CUST_DETAILS_TAG: "fetchCustDemogDetail",
  FETCH_BENEFICIARY_ACC_TAG: "fetchBeneficiaryAccName",
};
